import angular from 'angular';
import mediaAccountService from './media-account.service';

let mediaAccountModule = angular.module('media-account', [])

    .service('mediaAccount', mediaAccountService)

    .name;

export default mediaAccountModule;



// WEBPACK FOOTER //
// ./src/app/modules/media-account/media-account.js